import Entry from './Entry';

export default function PhoneFieldControl(props) {
  return (
    <Entry type="tel" {...props} />
  );
}
